export const module = {
  info: {
    name: 'jikatel-user-rate',
    caption: 'Jikatel User Rate'
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel',
  sideMenu: {
    caption: 'Jikatel User Rate',
    icon: 'el-icon-edit-outline',
    routeName: 'module->jikatel-user-rate->panel',
  }
}

export default module
